<template>
  <popup class="filter-box" v-model="showFilter" position="right" :overlay="false">
    <van-nav-bar class="nav-bar-filter" ref="navBar" title="Filter" id="navBar">
      <template #left>
        <svg @click="showFilter = false" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
          fill="none">
          <rect width="40" height="40" fill="white" />
          <path d="M8 30.6274L30.6274 8.00002" stroke="black" stroke-width="4" />
          <path d="M30.6289 30.6274L8.00149 8.00003" stroke="black" stroke-width="4" />
        </svg>
      </template>
    </van-nav-bar>
    <div class="filter-nr">
      <div class="filter-left">
        <span class="fl-title" :class="{ 'fl-title-on': filterTitle ? filterTitle == item.title : index == 0 }"
          @click="filterSelect(item.title)" v-for="item, index in filterList" :key="index">{{ item.title }}</span>
      </div>
      <div class="filter-right" id="filterRight">
        <div class="item" :ref="item.title" :id="item.title" v-for="item, index in filterList" :key="index">
          <span>{{ item.title }}</span>
          <div class="sub-list-box" v-if="item.subList.length > 0">
            <span :class="{ on: item.selelct == item1 }"
              @click="$set(item, 'selelct', item.selelct == item1 ? '' : item1)" v-for="item1, index1 in item.subList"
              :key="index1">
              {{ item1 }}
              <svg v-if="item.selelct == item1" xmlns="http://www.w3.org/2000/svg" width="28" height="28"
                viewBox="0 0 28 28" fill="none">
                <path d="M28 6.8343e-07L-1.22392e-06 1.90735e-06L28 28L28 6.8343e-07Z" fill="#6937E3" />
                <path d="M24.7578 12.5991L13.9988 1.84007" stroke="white" stroke-width="2.8" />
                <path d="M24.7578 1.83936L13.9988 12.5984" stroke="white" stroke-width="2.8" />
              </svg>
            </span>
          </div>
          <div class="input-box" v-if="item.title == 'Rrice Range'">
            <input v-model="item.priceMin" type="text" inputmode="numeric" v-enter-Price />
            <span>~</span>
            <input class="icon" v-model="item.priceMax" type="text" inputmode="numeric" v-enter-Price />
            <i>$</i>
          </div>
          <div class="input-box" v-if="item.title == 'Min.Stock'">
            <input v-model="item.kcMin" type="text" v-enter-number inputmode="numeric" />

          </div>
        </div>
      </div>
    </div>
    <div class="filter-btn-box">
      <span @click="filterClear()">Clear</span>
      <span @click="filterDone()">Done</span>
    </div>
  </popup>
</template>

<script>
import { popup } from 'vant';
export default {
  props: {
    value: [Boolean],
    data: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      showFilter: false,
      filterTitle: '',
      noScroll: false,
      timeout: '',
      filterList: [],
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.filterList = JSON.parse(JSON.stringify(this.data))
        this.showFilterView();
      } else {
        this.showFilter = val;
      }
    },
    showFilter(val) {
      this.$emit('input', val)
    }
  },
  created() {
  },
  components: {
    popup
  },
  methods: {
    filterSelect(val) {
      clearTimeout(this.timeout);
      this.noScroll = true;
      this.filterTitle = val;
      this.scrollToFilterRight(val);
      this.timeout = setTimeout(() => {
        this.noScroll = false;
      }, 500);
    },
    scrollToFilterRight(ref) {
      const filterRight = this.$refs[ref][0];
      if (filterRight) {
        filterRight.scrollIntoView({ behavior: 'smooth' });
      }
    },
    showFilterView() {
      this.showFilter = true;
      this.$nextTick(() => {
        document.getElementById('filterRight').onscroll = (e) => {
          if (!this.noScroll) {
            this.handleScroll(e)
          }
        }
      })
    },
    handleScroll(e) {
      const items = document.querySelectorAll('.item');
      const scrollPosition = e.target.scrollTop;
      items.forEach((item) => {
        const itemTop = item.getBoundingClientRect().top + e.target.scrollTop - e.target.getBoundingClientRect().top;
        if (scrollPosition >= itemTop && scrollPosition < itemTop + item.offsetHeight) {
          this.filterTitle = item.id;
        }
      });
    },
    filterClear() {
      this.filterList.forEach(item => {
        this.$set(item, 'selelct', '')
        this.$set(item, 'priceMax', '')
        this.$set(item, 'kcMin', '')
        this.$set(item, 'priceMin', '')
      })
      this.filterVal = '';
    },
    filterDone() {
      let val = '';
      this.filterList.forEach(item => {
        if (item.selelct) {
          val += item.selelct + ','
        }
        if (item.priceMax) {
          val += item.priceMax + ','
        }
        if (item.priceMin) {
          val += item.priceMin + ','
        }
        if (item.kcMin) {
          val += item.kcMin + ','
        }
      })
      this.filterVal = val;
      this.showFilter = false;
      this.$emit('onDone', { filterVal: this.filterVal, arr: this.filterList });
    }
  }
}
</script>

<style scoped lang="less">
.filter-box {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 88px;
  padding-bottom: 88px;

  ::v-deep .nav-bar-filter {
    position: static;

    svg {
      width: 40px;
      height: 40px;
    }
  }

  .filter-nr {
    width: 100%;
    flex: 1;
    border-top: 1px solid #D9D9D9;
    display: flex;
    overflow: hidden;

    .filter-left {
      width: 268px;
      display: flex;
      overflow-y: scroll;
      height: 100%;
      border-right: 1px solid #fff;
      padding: 0;
      flex-direction: column;
      background: #F1F1F1;

      .fl-title {
        height: 104px;
        width: 100%;
        border: 0;
        padding: 0 0 0 24px;
        display: flex;
        align-items: center;
        color: #666;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        background: #F1F1F1;

        &-on {
          background: #fff;
          color: #000;
        }
      }
    }

    .filter-right {
      flex: 1;
      overflow-y: scroll;
      height: 100%;
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 0 24px 32px;

      >div {
        display: flex;
        flex-direction: column;

        >span {
          margin: 32px 0 6px;
          color: #000;
          font-size: 30px;
          font-style: normal;
          font-weight: 600;
          line-height: 40px;
        }

        .sub-list-box {
          display: flex;
          flex-wrap: wrap;

          >span {
            border-radius: 2px;
            border: 1px solid #DCDCDC;
            background: #FFF;
            height: 58px;
            display: flex;
            align-items: center;
            position: relative;
            padding: 0 18px;
            margin-right: 12px;
            margin-top: 12px;
            font-size: 24px;
            overflow: hidden;

            >svg {
              position: absolute;
              top: -1px;
              right: -1px;
              width: 28px;
              height: 28px;
            }
          }

          .on {
            border: 2px solid #6937E3;
            color: #6937E3;
          }
        }


        .input-box {
          display: flex;
          margin-top: 18px;
          width: 326px;
          align-items: center;
          position: relative;

          >input {
            flex: 1;
            height: 64px;
            border-radius: 4px;
            border: 2px solid #DCDCDC;
            overflow: hidden;
            color: #111;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            width: 0;
            padding: 12px;
          }

          .icon {
            max-width: 140px;
            padding-left: 40px;
          }

          >i {
            overflow: hidden;
            color: #111;
            text-overflow: ellipsis;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            position: absolute;
            right: 107px;
          }

          >span {
            color: #000;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 44px;
            margin: 0 16px;
          }
        }
      }


    }

  }

  .filter-btn-box {
    margin-bottom: env(safe-area-inset-bottom);
    height: 119px;
    display: flex;
    align-items: center;
    border-top: 1px solid #DCDCDC;
    padding: 0 15px;

    >span {
      border-radius: 8px;
      border: 2px solid #6937E3;
      height: 88px;
      color: #6937E3;
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      margin: 0 15px;
    }

    >span+span {
      background: #6937E3;
      color: #fff;
    }
  }
}
</style>
